module.exports = __webpack_public_path__ + "img/ereszkalkulator_22_tetomagassag.2ad633e2.png";